@if (items.length > 1) {
  <nav class="tmw-app-breadcrumb" aria-label="breadcrumb">
    <ol class="tmw-steps">
      @for (item of items; track $index; let first = $first; let last = $last) {
        <li class="tmw-step" [class.first]="first" [class.active]="last" [attr.aria-current]="last ? 'page' : null">
          @if (!last && item.url) {
            <a class="tmw-step-label" [routerLink]="item.url">
              @if (first) {
                <i class="bi bi-house-door-fill"></i>
              }
              {{ labelOf(item) }}
            </a>
          } @else {
            <span class="tmw-step-label">
              @if (first) {
                <i class="bi bi-house-door-fill"></i>
              }
              {{ labelOf(item) }}
            </span>
          }
        </li>
      }
    </ol>
  </nav>
}
